<template>
  <div class="user_table">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="publishVisible"
      width="502px"
      title="发布新版本"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" v-if="publishVisible">
          <el-form-item
            prop="number"
            :required="true"
            label="versionName"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form.number"
              placeholder="请输入versionName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="versionCode"
            :required="true"
            label="versionCode"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form.versionCode"
              placeholder="请输入versionCode"
              autocomplete="off"
              @input="handleVersionCodeInput"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入描述"
              v-model="form.desc"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="URL" :label-width="formLabelWidth">
          <el-input v-model="form.url" placeholder="请输入名称" autocomplete="off"></el-input>
        </el-form-item> -->
          <el-form-item
            style="margin:0px 20px"
            label="操作系统"
            :label-width="formLabelWidth"
          >
            <template>
              <el-radio v-model="phone_radio" label="2">Android</el-radio>
              <el-radio v-model="phone_radio" label="1">IOS</el-radio>
              <el-radio v-model="phone_radio" label="3">Windows</el-radio>
              <el-radio v-model="phone_radio" label="5">Win7</el-radio>
              <el-radio v-model="phone_radio" label="4">Mac(Intel处理器)</el-radio>
              <el-radio v-model="phone_radio" label="6">Mac(Apple芯片/M系列)</el-radio>
            </template>
          </el-form-item>
          <el-form-item
            label="安装包"
            prop="url"
            :required="true"
            :label-width="formLabelWidth"
            v-if="phone_radio != 1"
          >
            <input type="file" id="selector" multiple />
            <el-button @click="upload()" size="small" type="primary"
              >点击上传</el-button
            >
            <div id="status">没有上传</div>
          </el-form-item>
          <el-form-item
            style="margin:0px 20px"
            label="三方登录"
            :label-width="formLabelWidth"
          >
            <template>
              <el-radio v-model="login_radio" label="1">开启</el-radio>
              <!-- <el-radio v-model="login_radio" label="2">关闭</el-radio> -->
            </template>
          </el-form-item>
          <el-form-item
            style="margin:0px 20px"
            label="是否强制更新"
            :label-width="formLabelWidth"
          >
            <template>
              <el-radio v-model="hard_radio" label="1">开启</el-radio>
              <el-radio v-model="hard_radio" label="2">关闭</el-radio>
            </template>
          </el-form-item>
          <el-form-item
            v-if="hard_radio === '1'"
            style="margin:0px 20px"
            prop="forceMinVersionCode"
            label="强制更新版本号"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form.forceMinVersionCode"
              placeholder="请输入版本号"
              autocomplete="off"
              @input="handleForceVersionCodeInput"
            ></el-input>
            <div
              style="font-size: 12px; color: #409EFF; margin-top: 5px;line-height: 16px;"
            >
              填写需要强制更新的历史版本号，该版本及以下版本均会执行强制更新操作
            </div>
          </el-form-item>
          <el-form-item
            style="margin:0px 20px"
            label="是否需要审核"
            :label-width="formLabelWidth"
          >
            <template>
              <el-radio v-model="update_radio" label="0">需要</el-radio>
              <el-radio v-model="update_radio" label="1">不需要</el-radio>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="up_publish('form')">发 布</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { user_detail } from "@/api/user";
import { new_publish, getUploadSignature } from "@/api/publish";
export default {
  components: {
    // ddbutton: () =>
    //   import(/* webpackChunkName: "design" */ "@/components/button")
  },
  data() {
    return {
      phone_radio: "2",
      hard_radio: "2",
      login_radio: "1",
      update_radio: "0",
      publishVisible: false,
      form: {
        number: "",
        versionCode: "",
        desc: "",
        url: "",
        forceMinVersionCode: "",
      },
      formLabelWidth: "110px",
      rules: {
        number: [
          { required: true, message: "请输入versionName", trigger: "blur" },
        ],
        versionCode: [
          { required: true, message: "请输入versionCode", trigger: "blur" },
          { validator: this.validatePositiveInteger, trigger: "blur" },
        ],
        url: [{ required: true, message: "请先上传安装包", trigger: "blur" }],
        forceMinVersionCode: [
          { validator: this.validatePositiveIntegerOptional, trigger: "blur" },
        ],
      },
      loading: null,
    };
  },
  mounted() {},
  methods: {
    init() {
      this.publishVisible = true;
    },
    // 验证正整数（必填）
    validatePositiveInteger(rule, value, callback) {
      if (!value) {
        callback(new Error('此字段为必填项'));
        return;
      }
      const num = parseInt(value, 10);
      if (isNaN(num) || num <= 0 || num.toString() !== value.toString()) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    // 验证正整数（可选）
    validatePositiveIntegerOptional(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      const num = parseInt(value, 10);
      if (isNaN(num) || num <= 0 || num.toString() !== value.toString()) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    // 处理versionCode输入，只允许数字
    handleVersionCodeInput(value) {
      this.form.versionCode = value.replace(/[^\d]/g, '');
    },
    // 处理forceMinVersionCode输入，只允许数字
    handleForceVersionCodeInput(value) {
      this.form.forceMinVersionCode = value.replace(/[^\d]/g, '');
    },
    up_publish(form) {
      let data = {
        auditing: this.login_radio, //三方登录是否开启 0未开启 1已开启
        client: this.phone_radio, //1.ios 2.安卓
        createTime: "", //不用传
        desc: this.form.desc, //描述
        downUrl: this.form.url, //url
        isMust: this.hard_radio, //是否必须 1是 2否
        versionName: this.form.number, //版本号
        versionCode: this.form.versionCode, //版本号
        auditing: this.update_radio,
        forceMinVersionCode: this.form.forceMinVersionCode || 0, //强制更新的历史版本号，没有填写时传0
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          new_publish(data)
            .then((res) => {
              this.publishVisible = false;
              this.$message({
                message: "发布成功",
                type: "success",
              });
              this.phone_radio = "2";
              this.hard_radio = "2";
              this.login_radio = "1";
              this.publishVisible = false;
              this.form = {
                number: "",
                desc: "",
                url: "",
                forceMinVersionCode: "",
              };
              this.$emit("father_fun");
            })
            .catch((error) => {
              this.$message({
                message: error.msg,
              });
            });
        } else {
          return false;
        }
      });
    },
    upload() {
      // 从输入元素中获取选中的文件。
      var files = document.querySelector("#selector").files;
      console.log(files);
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        // 从我们的服务器获取一个 URL。
        this.retrieveNewURL(file, (file, url) => {
          // 将文件上传到服务器。
          this.uploadFile(file, url);
        });
      }
    },
    retrieveNewURL(file, cb) {
      getUploadSignature(file.name).then((res) => {
        if (res.code == 1) {
          cb(file, res.data);
        }
      });
      // fetch(`/presignedUrl?name=${file.name}`).then((response) => {
      //     response.text().then((url) => {
      //         cb(file, url);
      //     });
      // }).catch((e) => {
      //     console.error(e);
      // });
    },
    uploadFile(file, url) {
      if (document.querySelector("#status").innerText === "没有上传") {
        document.querySelector("#status").innerHTML = "";
      }
      this.openFullScreen2();
      fetch(url, {
        method: "PUT",
        body: file,
      })
        .then(() => {
          // 如果上传多个文件，接下来将上传状态添加到下一行。
          this.form.url = file.name;
          document.querySelector(
            "#status"
          ).innerHTML += `<br>已上传 ${file.name}。`;
          this.loading.close();
        })
        .catch((e) => {
          this.$message.error("上传失败");
          console.error(e);
          this.loading.close();
        });
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    close() {
      this.publishVisible = false;
      this.phone_radio = "2";
      this.hard_radio = "2";
      this.login_radio = "1";
      this.publishVisible = false;
      this.form = {
        number: "",
        desc: "",
        url: "",
        forceMinVersionCode: "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.user_table {
  /deep/.el-dialog {
    width: 502px;
    @include dia_header_usual;
    @include dia_form;
  }

  .dialog-content {
    max-height: 60vh;
    overflow-y: auto;
    padding-right: 5px;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;

      &:hover {
        background: #a8a8a8;
      }
    }
  }
  .dialog-footer {
    padding-top: 10px;
  }
}
</style>
